package com.evoapps.evoshift.kiosk

import com.evoapps.evoshift.domain.usecase.kiosk.KioskStore

/** How this platform keeps the tablet on the app (SH-107). */
enum class KioskLockHint {
    /** The app pins itself (Android lock task, or screen pinning where the device asks first). */
    NONE,

    /** Apps cannot pin themselves: the manager turns on Guided Access (iPad). */
    GUIDED_ACCESS
}

/** Keeps the device on the app while it is a clock-in tablet. */
interface KioskDeviceLock {
    val hint: KioskLockHint
    fun enter()
    fun exit()
}

object NoKioskDeviceLock : KioskDeviceLock {
    override val hint = KioskLockHint.NONE
    override fun enter() = Unit
    override fun exit() = Unit
}

expect fun platformKioskDeviceLock(): KioskDeviceLock

/** A text value kept on the device under [key] (the tablet's queue and session). */
expect fun platformKioskStore(key: String): KioskStore

/** Kodein tags and store keys. */
object KioskStores {
    const val QUEUE = "kioskQueue"
}
